enum RegistrationStatus {
  REGISTRATION_INITIATED = "REGISTRATION_INITIATED",
  REGISTERED = "REGISTERED",
  REGISTRATION_CANCELED = "REGISTRATION_CANCELED",
  REGISTRATION_REJECTED = "REGISTRATION_REJECTED",
  REGISTRATION_TRANSFERRED = "REGISTRATION_TRANSFERRED",
  REGISTRATION_DELETED = "REGISTRATION_DELETED"
}

export function canShowConfirmationNumber(status: RegistrationStatus) {
  return status === RegistrationStatus.REGISTERED;
}

export default RegistrationStatus;
